import Vue from 'vue'
import axios from '@/plugins/axios'
import moment from 'moment'
import cookie from 'js-cookie'
import { store } from '@/main.js'
import { types as typesAuth } from "@/modules/auth/constant";
import { mapGetters } from "vuex";

Vue.mixin({
    data: function() {
        return {
            maximumImagePopup: 100,
            maximumThemePopup: 10,
            maximumImageInApp: 20,
            maximumThemeInApp: 1,
            maximumOptimize: 1000
        }
    },
    computed: {
        ...mapGetters({
            channels: typesAuth.getters.GET_CHANNELS,
            appPusher: typesAuth.getters.GET_APP_PUSHER
        })
    },
    methods: {
        redirect(route) {
            this.$router.push(route)
        },
        convertFileToWebkitURL(file){
            let URLObj = window.URL || window.webkitURL;
            let source = URLObj.createObjectURL(file);
            return source
        },
        setRouterLinkDefault({
            name,
            params,
            query
        }) {
            let current = {
                name: this.$route.name,
                params: this.$route.params,
                query: this.$route.query
            }
            if (name) {
                current.name = name
            }
            if (params) {
                current.params = params
            }
            if (query) {
                current.query = query
            }
            return current
        },
        createAxiosCancelRequestToken() {
            const CancelToken = axios.CancelToken;
            return CancelToken.source()
        },
        confirmBeforeRouteLeaveCustom({
            to,
            from,
            next,
            title = this.$t('app.confirm.route_leave.title'),
            content = this.$t('app.confirm.route_leave.content'),
            okText = this.$t('app.confirm.route_leave.ok_text'),
            cancelText = this.$t('app.confirm.route_leave.cancel_text'),
            okType = 'danger',
            okButtonProps = {
                class: `${this.$prefixClass.btn} ${this.$prefixClass.btn}-primary`
            },
            cancelButtonProps = {
                class: `${this.$prefixClass.btn}`
            },
            zIndex = 10002,
            closable = true
        }) {
            this.$confirm({
                title,
                content,
                okText,
                cancelText,
                okType,
                okButtonProps,
                cancelButtonProps,
                zIndex,
                closable,
                prefixCls: this.$prefixClass.modal,
                class: 'm-modal-discard-changes',
                onOk: () => {
                    next()
                },
                onCancel: () => {}
            })
        },
        createFormData: function (object, form, namespace) {
            const formData = form || new FormData();
            for (let property in object) {
                // if (!object.hasOwnProperty(property) || !object[property]) {
                //     continue;
                // }
                const formKey = namespace ? `${namespace}[${property}]` : property;
                if (object[property] instanceof Date) {
                    formData.append(formKey, object[property].toISOString());
                } else if (typeof object[property] === 'object' && !(object[property] instanceof File)) {
                    if (Array.isArray(object[property]) && object[property].length <= 0) {
                        formData.append(formKey, []);
                    } else {
                        this.createFormData(object[property], formData, formKey);
                    }
                } else {
                    formData.append(formKey, object[property]);
                }
            }
            return formData;
        },
        mappingObject(oldForm, newForm) {
            for (let property in oldForm) {
                if (!newForm.hasOwnProperty(property) || !newForm[property]) {
                    continue;
                }
                if (typeof (oldForm[property]) === 'object' && property != 'images') {
                    this.mappingObject(oldForm[property], newForm[property])
                } else {
                    oldForm[property] = newForm[property]
                }
            }
        },
        imageDefault() {
            return require('@/assets/images/no-img.png')
        },
        avatarDefault() {
            return require('@/assets/images/avatar-default.png')
        },
        pushRouterLinkDefault({
            name,
            params,
            query
        }) {
            // return new Promise((resolve, reject)=>{
            let current = {
                name: this.$route.name,
                params: this.$route.params,
                query: this.$route.query
            }
            if (name) {
                current.name = name
            }
            if (params) {
                current.params = params
            }
            if (query) {
                current.query = query
            }
            this.$router.push(current)
            // })
        },
        showFormErrors(message) {
            var content = ''
            if (message) {
                if (typeof message == 'string') {
                    content = message
                } else if (typeof message == 'object') {
                    for (const key in message) {
                        if (message.hasOwnProperty(key)) {
                            const element = message[key];
                            if (typeof element == 'object' && element.length) {
                                content = element[0]
                            }
                            break
                        }
                    }
                }
            }
            this.$notification['error']({
                message: 'Error',
                description: content,
            });
        },
        formatSize(sizeDefault) {
            let size;
            let sizeKB = (Number(sizeDefault) / 1024)
            if ( isNaN(sizeKB) ) sizeKB = 0
            // Lấy đơn vị kB
            if (sizeKB < 1000) {
                size = sizeKB.toFixed(1) + 'KB'
            }
            // Lấy đơn vị MB 
            else {
                size = (Number(sizeKB) / 1024).toFixed(1) + 'MB'
            }
            return size;
        },
        formatDateTimeLog(value) {
            let now = moment();
            if (now.diff(value, 'days', true).toFixed(0) >= 7) {
                return moment(value).format('LL')
            } else {
                return moment(value).toNow(true) + ' ago';
            }
        },
        formatStatus(status) {
            let currentStatus = ''
            switch (String(status)) {
                case 'compressed':
                    currentStatus = 'Optimized'
                    break;
                case 'restored':
                    currentStatus = 'Restored'
                    break;
                case 'failed':
                    currentStatus = 'Failed'
                    break;
                case 'already_compressed':
                    currentStatus = 'Already optimal'
                    break;
            }
            return currentStatus
        },
        formatPrice(value, numFixed) {
            if (isNaN(value)) {
                return 0
            }
            if (numFixed) {
                value = Number(value).toFixed(numFixed)
            }
            return '$' + value
        },
        moveLogDetail(id) {
            this.$router.push({
                name: this.$routerName.OPTIMIZATION_DETAIL,
                params: {id: id}
            })
        },
        toastInfo({ title = '', message = '', duration = 5, placement = 'topRight', className='' }) {
            this.$notification.open({
                'message': title,
                'icon': function(createElement) {
                    return createElement('span', {
                        class: 'fas fa-exclamation-circle',
                    })
                },
                'class': `${this.$prefixClass.toast}-info `+className,
                'prefixCls': this.$prefixClass.toast,
                'duration': duration,
                'description': message,
                'placement': placement
            });
        },
        onSlide(element) {
            let dotElem = element.target
            let currentPos = dotElem.getAttribute('data-pos')
            let sliderOne = document.querySelector('.slide-one')
            let sliderTwo = document.querySelector('.slide-two')
            let sliderThree = document.querySelector('.slide-three')
            let dotLeft = document.querySelector('.dot-active')
            switch(Number(currentPos)){
                case 0:
                    $(sliderOne).removeClass('d-none')
                    if (!sliderTwo.classList.contains('d-none')) {
                        $(sliderTwo).addClass('d-none')
                    }
                    if (sliderThree && !sliderThree.classList.contains('d-none')) {
                        $(sliderThree).addClass('d-none')
                    }
                break;
                case 1:
                    $(sliderTwo).removeClass('d-none')
                    if (!sliderOne.classList.contains('d-none')) {
                        $(sliderOne).addClass('d-none')
                    }
                    if (sliderThree &&  !sliderThree.classList.contains('d-none')) {
                        $(sliderThree).addClass('d-none')
                    }
                break;
                case 2:
                    $(sliderThree).removeClass('d-none')
                    if (!sliderOne.classList.contains('d-none')) {
                        $(sliderOne).addClass('d-none')
                    }
                    if (!sliderTwo.classList.contains('d-none')) {
                        $(sliderTwo).addClass('d-none')
                    }
                break;
            }
            $(dotLeft).removeClass('dot-active')
            $(dotElem).addClass('dot-active')
        },
        showModalResult(modal) {
            modal.optType = modal.optType == undefined ? 'image' : modal.optType;
            let self = this;
            this.$confirm({
                content: (
                    <div class="text-center">
                        <div class={modal.type == 'needed' ? '' : 'd-none'}>
                            <i class="fad fa-info-circle"></i>
                            <h4 class="m-b-12">{this.$t('optimize_image.optimization_result.'+ modal.type +'.title')}</h4>
                            <span class={modal.optType == 'image' ? '' : 'd-none'}>Optimize these <strong>{modal.detail.images} images</strong> for <strong>{this.formatSize(modal.detail.saved)}</strong> potential savings</span>
                            <span class={modal.optType == 'theme'? '' : 'd-none'}>Optimize these <strong>{modal.detail.files} files</strong> to boost your loading speed</span>
                            <span class={modal.optType == 'all'? '' : 'd-none'}>Optimize these <strong>{modal.detail.files} files</strong> and <strong>{modal.detail.images} images</strong><br></br>for <strong>{this.formatSize(modal.detail.saved)}</strong> potential savings</span>
                        </div>
                        <div class={modal.type == 'summary' ? '' : 'd-none'}>
                            <div class="m-modal-confirm-header text-left">
                                <h4 class="m-b-0">{this.$t('optimize_image.optimization_result.'+ modal.type +'.title')}</h4>
                            </div>
                            <hr class="m-0"></hr>
                            <div class="m-modal-confirm-summary text-center">
                                <span class="fz-18">Your store is now faster</span>
                                <div class="d-flex align-items-center justify-content-center m-t-8">
                                    <div class="m-r-4 arrow-wrap">
                                        <i class="fas fa-arrow-down"></i>
                                    </div>
                                    <h3 class={modal.optType == 'image' ? 'm-b-0 success-color' : 'd-none'}>{modal.detail.images} Images</h3>
                                    <h3 class={modal.optType == 'theme' ? 'm-b-0 success-color' : 'd-none'}>{modal.detail.files} Files</h3>
                                </div>
                                <span class="text-color-secondary">Optimized</span>
                            </div>
                        </div>
                </div>
                ),
                class: `m-optimization-result ` + modal.type,
                centered: true,
                closable: true,
                cancelButtonProps: {
                    class: `${this.$prefixClass.btn} btn-cancel`
                },
                okButtonProps: {
                    class: `${this.$prefixClass.btn} ${this.$prefixClass.btn}-primary btn-ok`
                },
                prefixCls: this.$prefixClass.modal,
                cancelText: `${this.$t('optimize_image.optimization_result.'+ modal.optType + ( modal.type === 'summary' ? '.summary_btn_cancel' :'.needed_btn_cancel' ))}`,
                okText: `${this.$t('optimize_image.optimization_result.'+ modal.optType + ( modal.type === 'summary' ? '.summary_btn_ok' :'.needed_btn_ok' ))}`,
                onOk : ()=>{
                    if (modal.type == 'summary') {
                        if (modal.optType == 'image') {
                            this.$router.push({
                                name: this.$routerName.OPTIMIZATION_DETAIL,
                                params: {id: modal.detail.logId}
                            })
                        }
                        else {
                            store.commit('setShowPreviewTheme', true)

                            // Open modal publish store
                            self.$router.push({
                                name: this.$routerName.OPTIMIZE_IMAGE
                            })
                        }
                    }
                    else {
                        cookie.set('show-modal-result', true, { expires: 1 })
                        store.commit('setAutoOpenOptimizeMethod', true)
                        this.$router.push({
                            name: this.$routerName.OPTIMIZE_IMAGE
                        })
                    }
                },
                onCancel: () => {
                    cookie.set('show-modal-result', true, { expires: 1 })
                    // this.$destroy()
                }
            });
        },
        getImgUrl(pic) {
            return require('@/assets/' + pic)
        },
        formatLogId(logId, key = 'SW') {
            var strLogId = logId.toString();
            var temp = '';
            for (var i = strLogId.length; i < 5; i++) {
                temp += '0';
            }
            return key + temp + strLogId;
        },
        rateData(original, optimized) {
            let originalSz = Number(original);
            let optimizedSz = Number(optimized);
            let rate = (((optimizedSz - originalSz) / originalSz) * 100);
            if (rate > 0 && rate < 1) {
                rate = 1;
            } else if (rate > -1 && rate < 0) {
                rate = -1;
            } else if (isNaN(rate)) {
               rate = 0;
            }
            return rate.toFixed(0);
        },
        remove_character(str, str_to_remove) {
            let reg = new RegExp(str_to_remove)
            return str.replace(reg, '')
        },
        openBoxChat() {
            if ($crisp.is("chat:opened") === false) {
                $crisp.push(['do', 'chat:open'])
            }
            // if ($linebase.is("widget", "opened") === false) {
            //         $linebase.do('widget','open')
            // }
        },
        channelBindEvent({channelType=''}, callBack) {
            if (!channelType) return;
            let dataChannel = this.channels.find(c => c.type == channelType)
            let channel = this.appPusher.channels.channels[dataChannel.channelName]
            channel.bind(`${dataChannel.eventName}`, callBack)
        },
        channelUnbindEvent(channelTypes=[]) {
            if (channelTypes.length <= 0) return;
            
            channelTypes.forEach(type => {
                let dataChannel = this.channels.find(c => c.type == type)
                let channel = this.appPusher.channels.channels[dataChannel.channelName]
                channel.unbind(`${dataChannel.eventName}`)
            });
        },
        displayPlanName(_plan = '') {
            let plan = _plan ? _plan : '',
                planNew = ''
            switch(plan.toLowerCase()){
                case 'free':
                    planNew = 'basic'
                    break;
                case 'premium':
                    planNew = 'premium';
                    break;
            }
            return planNew;
        }
    }
})
